const BASE_ORIGIN_PREFIX = 'imarketing';
// api.imarket.intlgame.com
export const cgiModeMap = {
  dev: ``,
  test: `api-test.${BASE_ORIGIN_PREFIX}.intlgame.com`,
  prerelease: `api-pre.${BASE_ORIGIN_PREFIX}.intlgame.com`,
  production: `api.${BASE_ORIGIN_PREFIX}.intlgame.com`,
};
export const webModeMap = {
  dev: `local.${BASE_ORIGIN_PREFIX}.intlgame.com`,
  test: `test.${BASE_ORIGIN_PREFIX}.intlgame.com`,
  prerelease: `pre.${BASE_ORIGIN_PREFIX}.intlgame.com`,
  production: `${BASE_ORIGIN_PREFIX}.intlgame.com`,
};

export const codeMessage = {
  400: 'The request sent has errors, and the server did not create or modify any data.',
  401: 'User does not have permission (token, username, or password is incorrect).',
  403: 'Please check if the iOA or VPN connection is normal.',
  404: 'The request targets a record that does not exist, and the server did not perform any operations.',
  406: 'The requested format is not acceptable.',
  410: 'The requested resource has been permanently deleted and will not be obtained again.',
  422: 'A validation error occurred when creating an object.',
  500: 'An error occurred on the server, please check the server.',
  502: 'Bad gateway.',
  503: 'Service unavailable, the server is temporarily overloaded or under maintenance.',
  504: 'Gateway timeout.',
  // 302 Redirect
};
